const contact = {
    title: 'ขอรับความช่วยเหลือ',
    description: 'สำหรับการขอความช่วยเหลือหรือข้อเสนอแนะเกี่ยวกับผลิตภัณฑ์ กรุณาติดต่อเราผ่านช่องทางต่อไปนี้',
    discord: {
        title: 'เข้าร่วมชุมชน Discord',
        description: 'เชื่อมต่อกับนักพัฒนาคนอื่นเพื่อหาวิธีแก้ปัญหา',
        button: 'เข้าร่วม',
    },
    github: {
        title: 'พูดคุยบน GitHub',
        description: 'สร้าง issue และส่งเข้าที่ GitHub',
        button: 'เปิด',
    },
    email: {
        title: 'ติดต่อฝ่ายสนับสนุนทางอีเมล',
        description: 'ส่งอีเมลถึงเราเพื่อรับข้อมูลและความช่วยเหลือเพิ่มเติม',
        button: 'ส่ง',
    },
    reserve: {
        title: 'จองเวลาคุยกับทีม Logto',
        description: 'จองเวลาพูดคุยสดได้อย่างรวดเร็ว',
        button: 'จอง',
    },
};
export default Object.freeze(contact);
